import { createRouteRef } from '@backstage/core-plugin-api';

export const engineeringExcellenceRouteRef = createRouteRef({
  id: 'engineering-excellence',
});

/** Entity-content path of the Focus Areas tab; the dashboard links straight to it. */
export const FOCUS_AREAS_TAB_PATH = '/focus-areas';
